import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloMuroLambrinSintetico from '../components/sections/MuroLambrinSintetico/TituloMuroLambrinSintetico'; 
import IntroLambrinSintetico from '../components/sections/MuroLambrinSintetico/IntroLambrinSintetico'; 
import DescripcionLambrin from '../components/sections/MuroLambrinSintetico/DescripcionLambrin'; 
import AplicacionesLambrin from '../components/sections/MuroLambrinSintetico/AplicacionesLambrin';
import PorQueLambrin from '../components/sections/MuroLambrinSintetico/PorQueLambrin'; 
import FormularioContactoLambrin from '../components/sections/MuroLambrinSintetico/FormularioContactoLambrin'; 
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroLambrinSinteticoPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Lambrín Sintético para Muros | Decototal"
        description="Encuentra lambrín sintético para decorar y renovar muros interiores. Descubre sus aplicaciones y solicita asesoría para elegir tu acabado."
        keywords="lambrín sintético, lambrín para muro, revestimiento sintético, panel decorativo"
        path="/muro-lambrin-sintetico-page"
        image="/assets/img/productos/muro-lambrin-sintetico/muro-lambrin-sintetico-titulo.jpg"
      />
      <Header />
        <TituloMuroLambrinSintetico /> 
        <IntroLambrinSintetico />   
        <DescripcionLambrin />  
        <AplicacionesLambrin />
        <PorQueLambrin /> 
        <FormularioContactoLambrin />
      <Footer />
    </div>
  );
};

export default MuroLambrinSinteticoPage;